import { React, useEffect, useState, useContext } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { GlobalLoading, showLoading } from "react-global-loading";
import { MyContextProvider } from "../../../App";
import { API_URL } from "../../../Constant";
import DataTable from "react-data-table-component";
import { converDateFormat } from "../../../Custom/Custom";
import { Link,useNavigate   } from "react-router-dom";
import messages from '../../../assets/Messages.json';


function ViewUserList() {
  const [userList, setUserList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate ();
  const token = useContext(MyContextProvider).token;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
     getUserData();
   }, []);



  const togglePasswordVisibility = (USER_ID) => { 
    console.log(USER_ID)
    setUserList(userList.map(pwd => pwd.USER_ID === USER_ID ? { ...pwd, VISIBLE: !pwd.VISIBLE } : pwd )); 
  };


  const getUserData= async()=>{

    showLoading(true);
    axios
      .get(`${API_URL}api/getAllusersList`, config)
      .then((res) => {
        let userList = res.data;
        if (userList.status) {
         
          const modifiedData = userList.data.map((item) => {
           
            return {
              ...item,
               CREATED_TIME: converDateFormat(new Date(item.CREATED_TIME)),
               LAST_LOGIN: lastDateFunction(item.LAST_LOGIN),
               VISIBLE: false
              //  "edit": `Edit`
            };
          });
       
        setUserList(modifiedData);
          showLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        showLoading(false);
      });

  }

  const lastDateFunction = (lastDate) => {
    if (lastDate === null || lastDate === undefined || lastDate === '' || lastDate === '0000-00-00 00:00:00') {
      return 'NA';
    }
  
    const parsedDate = new Date(lastDate);
    return isNaN(parsedDate.getTime()) ? 'NA' : converDateFormat(parsedDate);
  };



// const lastDateFunction=(lastDate)=>{
//   let  date= 'NA';
//    if(lastDate !== '0000-00-00 00:00:00'){
//     // const inputDate = moment(new Date(e.target.name)).format("YYYY-MM-DD")
//     // date= moment("2024-12-11 17:17:10").format('MMMM DD, YYYY hh:mm:ss A');
//     date=converDateFormat(new Date(lastDate))
//    }
//  return  date;
// }

  const handleEditClick = (row) => {
     navigate('/addUser', { state: { userEditDataObject: row } });
  };

 const handelResetPassword = async(userId)=>{
  const confirmed = window.confirm(`Are you sure to reset password for user: ${userId}`);
  if (confirmed) {
    showLoading(true);
    try {
      const response = await axios.get(`${API_URL}api/account/resetPassword/${userId}`, config);
      if(response.data.status){
          toast.success(response.data.message , messages.COLOR_RED);
       }else{
        toast.error(response.data.message, messages.COLOR_RED);
      }
     } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      showLoading(false);
     
    }
  } else {
    console.log('Password reset canceled');
  }
}


const handelUserLockStatus = async(userId,currentLockStatus)=>{

  
  const confirmed = window.confirm(`Are you sure, Want to change login status for user: ${userId}`);

  if (confirmed) {
    showLoading(true);
    try {
      const status=(currentLockStatus==='A') ? 'L':'A';
      const response = await axios.put(`${API_URL}api/account/updateUserLockStatus/${userId}`,{'Lock_Status':status}, config);
      if(response.data.status){
          getUserData()
          toast.success(response.data.message , messages.COLOR_RED);
       }else{
        toast.error(response.data.message, messages.COLOR_RED);
      }
     } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      
     showLoading(false)
    }
  } else {
    console.log('Change status canceled');
  }
}




  const columns = [
    { name: "User Id", selector: (row) => row.USER_ID, sortable: true,maxWidth: "15px"},
    { name: "User Name", selector: (row) => row.USER_NAME, sortable: true ,maxWidth: "126px"},
    { name: "User Type", selector: (row) => row.USER_TYPE, sortable: true ,maxWidth: "150px"},
    { name: "User Role", selector: (row) => row.ROLE_CODES, sortable: true ,maxWidth: "130px"},
    { name: "Created On", selector: (row) => row.CREATED_TIME, sortable: true },
    { name: "Last Login", selector: (row) => row.LAST_LOGIN, sortable: true },
    { name: "Password", selector: (row) => row.VISIBLE?row.PASSWORD: '*****', sortable: false,maxWidth: "180px" ,

      
    },
    {
      name: "Action",
      cell: (row) => (
        <>
        <Link to="#" onClick={(e) => { e.preventDefault(); handleEditClick(row); }}><i className="fa fa-edit fs-4" title="Edit"></i></Link>
        <Link to="#" onClick={(e) => { handelResetPassword(row.USER_ID); }}>
          <i className="fa fa-key fs-4 mx-3" title="Reset Password"></i>
          </Link>
        <Link to="#" onClick={(e) => { handelUserLockStatus(row.USER_ID,row.LOCK_STATUS); }}>
          <i className={`fa ${row.LOCK_STATUS==='A'? 'fa-unlock':'fa-lock'} fs-4 text-success`} title="Login Status"></i>
        </Link>
        <Link to="#" onClick={() => togglePasswordVisibility(row.USER_ID)}>
          <i className={`fa ${row.VISIBLE ? 'fa-eye': 'fa-eye-slash'}  fs-4 text-success mx-3` } title="Password"></i>
        </Link>
      </>
      ),
      center:'true'
    },
  ];

  const customFilter = (rows, searchTerm) => {
    // showLoading(true)
    return rows.filter((row) => {
      const userId = row.USER_ID && row.USER_ID.toLowerCase();
      const userName = row.USER_NAME && row.USER_NAME.toLowerCase();
      const userType = row.USER_TYPE && row.USER_TYPE.toLowerCase();
      const roleCode = row.ROLE_CODES && row.ROLE_CODES.toLowerCase();
      const createdTime = row.CREATED_TIME && row.CREATED_TIME.toLowerCase();
      return (
        (userId && userId.includes(searchTerm.toLowerCase())) ||
        (userName && userName.includes(searchTerm.toLowerCase())) ||
        (userType && userType.includes(searchTerm.toLowerCase())) ||
        (roleCode && roleCode.includes(searchTerm.toLowerCase())) ||
        (createdTime && createdTime.includes(searchTerm.toLowerCase()))
      );
    });
  };

  const customStyles = {
    rows: {
      style: {
        background: "#f2f2f2",
      },
    },

    table: {
      style: {
        border: "2px solid #ddd",
      },
    },
    headCells: {
      style: {
        fontSize: "15px",
        fontWeight: "bold",
      },
    },
  };

  return (
    <>
      <ToastContainer />
      <GlobalLoading />

      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value.trim())}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 mb-4">
                <DataTable
                  title=""
                  columns={columns}
                  data={
                    searchText.trim() !== ""
                      ? customFilter(userList, searchText)
                      : userList
                  }
                  pagination
                  customStyles={customStyles}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewUserList;
